import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

import { getCurrentAgent } from '../services/localStorageService';
import { ROUTE_LOGIN } from './paths';

const PrivateRoute: React.FC<RouteProps> = ({ component: Component, ...rest }) => {
    if (!Component) {
        return null;
    }

    return (
        <Route
            {...rest}
            render={(props) => {
                const agent = getCurrentAgent();
                if (!agent) {
                    return <Redirect to={ROUTE_LOGIN} />;
                }

                return <Component {...props} />;
            }}
        />
    );
};

export default PrivateRoute;
